import { IModeleAnswer } from 'core/interfaces/Ask'
import { useTranslation } from 'react-i18next'
import React from 'react'
import { IModele } from 'core/interfaces/Modele'
import { DownloadResultButtons } from 'core/components/conversation/DowloadResultButtons'

export const PromptTestResult: React.FC<{
  answers: IModeleAnswer[]
  modeles: IModele[] | undefined
  formats: string[] | null | undefined
}> = ({ answers, modeles, formats }) => {
  const { t } = useTranslation()

  return (
    <div>
      <div className="w-full flex flex-row gap-x-[20px]">
        {answers.length > 0 ? (
          answers.map((answer, index) => (
            <div
              key={index}
              className="prompt-test-result bg-white dark:bg-gray-1600"
            >
              <div className="answer-parameter">
                <div className="font-medium">
                  {
                    modeles?.find((modele) => modele.nom === answer.modeleName)
                      ?.label
                  }
                </div>
                <div>
                  {answer.time && Math.round(answer.time * 100) / 100}ms
                  {answer.answer?.total_cost !== undefined && (
                    <>
                      &nbsp;/&nbsp;
                      {Math.round(answer.answer.total_cost * 100000) / 100000}€
                    </>
                  )}
                </div>
              </div>
              <div>{answer.answer.answer}</div>
              {formats && formats.length > 0 && (
                <div className="my-10px">
                  <DownloadResultButtons
                    message={answer.answer.answer}
                    formats={formats}
                  />
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="prompt-test-result text-gray-1250 bg-white-150 dark:bg-gray-1600">
            <div className="font-medium mb-[10px]">
              {t('prompts.form.result')}
            </div>
            <span>{t('prompts.form.noResult')}</span>
          </div>
        )}
      </div>
    </div>
  )
}
